export const getRequestTreatedBy = (request) => {
    const handledByAdmin = request?.adminDecision === true || request?.adminDecision === false;

    if (handledByAdmin) {
        return request?.adminName || "Admin RH";
    }

    return request?.managerName || "Manager";
};
